export const checkDateBefore = (startDate: Date, endDate: Date): boolean => {
  const diffTime = startDate.valueOf() - endDate.valueOf();
  return diffTime < 0;
};
